///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { debounceTime, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { limitOrderInputFormActions } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import type { LimitOrderInputFormSelectors } from 'state/secondaryMarket/limit-order/form/input/inputForm.selectors';
import type { EpicWithThunk } from 'state/state.common';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';

export function triggerLimitOrderTabContentPersistenceEpic(
  getFormTabContentToPersist: LimitOrderInputFormSelectors['getFormTabContentToPersist'],
): EpicWithThunk {
  return (actions$, state$, { scheduler }) => {
    const newForm$ = actions$.pipe(
      ofType('WORKSPACE_TAB_CREATED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketQuotes' && tabType === 'limitOrder'),
      map(({ id }) => id),
    );
    const modifyForm$ = actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_FORM_FIELD_CHANGED'),
      debounceTime(3_000, scheduler),
      map(({ tabId }) => tabId),
    );
    return merge(modifyForm$, newForm$).pipe(
      withLatestFrom(state$),
      mergeMap(([tabId, state]) => {
        const persistedTabContent = getFormTabContentToPersist(state, tabId);
        if (persistedTabContent === undefined) {
          return EMPTY;
        }
        const workspaceType = getWorkspaceType(state, tabId) as SecondaryWorkspaceType;
        return of(limitOrderInputFormActions.tabContentPersistenceRequested(tabId, workspaceType, persistedTabContent));
      }),
    );
  };
}
